import { BaseClass } from './base-class';
import { BaseRepository } from '@interfaces/base-repository';
import type { Site } from './site';

export class Client extends BaseClass implements BaseRepository {
  name: string;
  // features: Feature[];
  email: string;
  phone: string;
  fax: string;
  contact: string;
  webSite: string;
  street: string;
  streetNumber: string;
  locality: string;
  postalCode: string;
  siret: string;
  ape: string;
  tva: string;
  isSubcontractor: boolean;
  selected?: boolean;
  site?: Site;
  siteId?: string;

  hasLogo?: boolean;

  constructor();
  constructor(
    name: string,
    email: string,
    phone: string,
    fax: string,
    contact: string,
    webSite: string,
    street: string,
    streetNumber: string,
    locality: string,
    postalCode: string,
    siret: string,
    ape: string,
    tva: string,
    isSubcontractor: boolean,
  );
  constructor(
    name?: string,
    email?: string,
    phone?: string,
    fax?: string,
    contact?: string,
    webSite?: string,
    street?: string,
    streetNumber?: string,
    locality?: string,
    postalCode?: string,
    siret?: string,
    ape?: string,
    tva?: string,
    isSubcontractor?: boolean,
  ) {
    super();

    this.name = this.trim(name);
    this.email = email;
    this.phone = phone;
    this.fax = fax;
    this.contact = contact;
    this.webSite = webSite;
    this.street = street;
    this.streetNumber = streetNumber;
    this.locality = locality;
    this.postalCode = postalCode;
    this.siret = siret;
    this.ape = ape;
    this.tva = tva;
    this.isSubcontractor = isSubcontractor;
  }

  static fromObject(object: Client): Client {
    return Object.assign(new Client(), {
      ...object,
    });
  }

  get display(): string {
    return `${this.name}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.name], value);
  }
}
